import styled from 'styled-components'
import { IconButton } from '@material-ui/core'
import { colors } from '../../styles'

export const StyledActionWrapper = styled.nav`
  display: flex;
  align-items: baseline;
` as React.ComponentType<any>

export const StyledIconButton = styled(IconButton)`
  color: ${colors.white};
  border-radius: 0;

  &:hover:not(.active) {
    background-color: rgba(255, 136, 0, 0.1);
  }
  &.active {
    background-color: ${colors.portal};
  }
` as React.ComponentType<any>
